/**
 * Avalara © 2019
 * file: engines/opus_ui/src/EngineItem.js
 */

import React from 'react';
import './EngineItem.css';

export default function EngineItem(props) {
  return (
    <div className="engine">
      <h1 className="engineName">{props.name}</h1>
    </div>
  );
}
